/**
 * The help articles describe the hotel app (front desk, rates, stock,
 * finance). The admin app has no help set of its own, so it shows no help
 * entry, route or drawer rather than the hotel tree.
 */
export function isHelpAvailable(appType: 'admin' | 'host' = __APP_TYPE__): boolean {
  return appType === 'host'
}
